<template>
  <div v-if="socialView">
    <div class="shortform-sign-up__partition">
      <span class="shortform-sign-up__partition-text d-none d-md-block"
        >Or</span
      >
      <span class="shortform-sign-up__partition-text d-md-none">
        {{ title }}</span
      >
    </div>
    <div class="shortform-sign-up__other-way">
      <FormError :errors="socialView.validation.errors" field="social" />
      <GoogleSignInButton
        v-if="showGoogle"
        :authMode="authMode"
        :view="socialView.googleAuthView"
      />
      <FacebookLoginButton :title="title" :view="socialView.facebookAuthView" />
      <AppleSignInButton
        v-if="socialView.appleAuthView"
        :view="socialView.appleAuthView"
        :title="title"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import {
  SocialAuthComponentView,
  createSocialAuthView,
} from '@/models/auth/social'

import FormError from '@/components/ui/FormError.vue'
import GoogleSignInButton from './GoogleSignInButton.vue'
import FacebookLoginButton from './FacebookLoginButton.vue'
import AppleSignInButton from './AppleSignInButton.vue'
import { AuthMode } from '@/models/auth/google'

const props = withDefaults(
  defineProps<{
    onStart: any
    onSuccess: any
    onError: any

    authMode: AuthMode
    showGoogle?: boolean
  }>(),
  {
    showGoogle: true,
  },
)

const title = ref('')

const socialView = ref<SocialAuthComponentView | null>(null)

onBeforeMount(async () => {
  title.value =
    props.authMode === AuthMode.Signin ? 'Sign in with' : 'Sign up with'

  socialView.value = await createSocialAuthView(
    props.onStart,
    props.onSuccess,
    props.onError,
  )
  if (socialView.value) {
    socialView.value.init()
  }
})
</script>
